import React,{useEffect, useState} from "react";
import {getFields} from "../../../../../dialog/formfields";
import {IconButton, Menu, MenuItem} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MDBox from "../../../../../../components/MDBox";
import TabPageHeader from "../../header/tabpageheader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import GenericForm from "../../../../../dialog/genericform";
import DataTableConfig from "../../../../../Tables/DataTableConfig";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";
import tableData from "../../../../../tabledata";

const InstallmentConfig = ({ selectedRowData }) => {
    const { installmentConfigColumns } = tableData();
    const { installmentConfigFields } = getFields();
    const [installmentConfig, setInstallmentConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create Installment Config");
    const api = useConfigApi();
    const [installmentConfigFieldsModified, setInstallmentConfigFieldsModified] = useState([]);


    const handleClick = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create Installment Config");

    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRowIndex(null);
    };

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveRowIndex(index);
    };

    const handleActionClick = (action: string, item) => {
        const row = installmentConfig[activeRowIndex];
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogData({
                ...row,
                hostReference: row.hostReference.map(s => s.slNo).join(", ")
            });
            setDialogTitle("View Installment Config");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit Installment Config");
            setDialogData({
                ...row,
                hostReference: row.hostReference.map(s => s.slNo).join(", ")
            });
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete Installment Config");
            setDialogData(row);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        console.log("Submitted data:", formData, dialogMode);
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        // formData.hostConfigSerialNumber = formData.hostReference;
        formData.hostConfigSerialNumber = formData.hostReference.split(",")
        .map(s => s.trim())
        .filter(s => s.length > 0)
        .map(Number);
        // Call your API here
        if (dialogMode === "create") {
            // Handle create logic here
            api.post(Endpoints.installmentConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Installment config successfully created.");
                    fetchInstallmentConfigs().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        } else if (dialogMode === "edit") {
            api.put(Endpoints.installmentConfig.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Installment config successfully updated.");
                    fetchInstallmentConfigs().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while updating.");
                });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.slNo) {
            toast.error("Missing slNo for deletion.");
            return;
        }
        api.delete(Endpoints.installmentConfig.deleteBySlNo(formData.slNo))
            .then(() => {
                toast.success(`Installment config ${formData.slNo} successfully deleted.`);
                fetchInstallmentConfigs().catch(console.error);
            })
            .catch(() => {
                toast.error("Error deleting header config.");
            });
    };

    useEffect(() => {
        fetchInstallmentConfigs().catch(console.error);
    },[]);

    const fetchInstallmentConfigs = async () => {
        try {
            // 1. Fetch Control Config
            const installmentConfigResponse = await api.get(Endpoints.installmentConfig.getByControlSlNo(selectedRowData.slNo));
            const installmentConfig = installmentConfigResponse?.data?.data || [];

            // 2. Fetch Groups
            const hostResponse = await api.get(Endpoints.hostConfig.getByControlSlNo(selectedRowData.slNo));
            const hosts = hostResponse?.data?.data || [];

            // 3. Format Table Data
            const modifiedData = installmentConfig.map((item, index) => {
                const action = (
                    <>
                        <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                            <MoreHorizIcon />
                        </IconButton>
                    </>
                );

                const hostReferenceLabels = item.hostReference.map(s => s.label);
                return { ...item, action, hostReferenceLabels };
            });

            setInstallmentConfig(modifiedData);

            // 4. Prepare Options for Select Field
            const hostOptions = hosts.map((host) => ({
                label: host.label,
                value: host.slNo
            }));

            setInstallmentConfigFieldsModified(installmentConfigFields.map(field =>
                field.name === "hostReference"
                    ? { ...field, options: hostOptions}
                    : field
            ));

        } catch (error) {
            toast.error("Error while fetching installment config or host data.");
            console.error(error);
        }
    };
    return <>
        <MDBox
            sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}
        >
            <TabPageHeader
                title="Installment Config"
                showButton={true}
                buttonLabel = "Add"
                onButtonClick={handleClick}

            />
        </MDBox>
        <MDBox sx={{
            px: 3,
            py: 2,
            bgcolor: "#fff",
            borderBottom: "1px solid #d3e3fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            overflowX: "auto",
            width: "100%",
        }}>


            <DataTableConfig
                table={{ columns : installmentConfigColumns, rows : installmentConfig }}
                showTotalEntries={true}
                isSorted={true}
                noEndBorder
                entriesPerPage={true}
                canSearch={true}
            />
        </MDBox>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            onClick={handleMenuClose}
        >
            <MenuItem onClick={() => handleActionClick("View")}>
                <IconButton size="small">
                    <i className="material-icons">visibility</i>
                </IconButton>
                View
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Edit")}>
                <IconButton size="small">
                    <EditIcon fontSize="small" />
                </IconButton>
                Edit
            </MenuItem>
            <MenuItem onClick={() => handleActionClick("Delete")}>
                <IconButton size="small" color="error">
                    <DeleteIcon fontSize="small" />
                </IconButton>
                Delete
            </MenuItem>
            {/*<MenuItem onClick={() => handleActionClick("Sync")}>*/}
            {/*    <IconButton size="small" color="error">*/}
            {/*        <RefreshIcon fontSize="small" />*/}
            {/*    </IconButton>*/}
            {/*    Sync*/}
            {/*</MenuItem>*/}
        </Menu>
        <GenericForm
            open={isModalOpen}
            handleClose={closeModal}
            title={dialogTitle}
            fields={installmentConfigFieldsModified}
            onSubmit={handleDialogSubmit}
            onDelete={handleDialogDelete}
            initialData={dialogData}
            mode={dialogMode}
            useDialog={true}
        />
           </>
};
InstallmentConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};

export default InstallmentConfig;
